import axios from 'axios'
import {state as appState} from "@/store/app";
import {backendUrl} from '../config'

const BackendAPI = axios.create({
	baseURL: backendUrl + (appState.language) + '/',
})

export default BackendAPI
